import React from 'react';
import Card from './card';
import { useTranslation } from 'react-i18next';

const AppLogoTitleSetting = () => {
    const { t } = useTranslation();
    
    return (
        <div className='space-y-5'>
            <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('menu.setting')}</h1>
            <Card t={t} />
        </div>
    );
};

export default AppLogoTitleSetting;
